import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import GoalContentAggQuery, {
	type GoalContentAggQuery as GoalContentAggQueryType,
} from '../components/GoalContent/agg/__generated__/GoalContentAggQuery.graphql';

export const goalContentAggResource = createRelayResource<GoalContentAggQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const containerId = (resourceContext as ResourceContext).collabContext?.contextId ?? '';
		const key = routerContext.match.params.id ?? '';
		return {
			query: GoalContentAggQuery,
			environment: getAggRelayEnvironment(),
			variables: {
				goalKey: key,
				containerId,
			},
		};
	},
});
